import React from "react";
import QuestionAnswers from "./QuestionAnswers";

const Worry = () => {
  return (
    <div className="w-full max-w-[1100px] md:w-[100%] mx-auto mb-4 md:mb-8" id="questions">
      <h2 className="mb-2 md:mb-12 relative">よくある質問</h2>
      <QuestionAnswers />
    </div>
  );
};

export default Worry;
